import { RadiusUnitEnum, SearchPostingTypeEnum } from '../../enums';

export interface DpsPostingFilterInputInterface {
  searchPostingTypes?: SearchPostingTypeEnum[];
  longitude?: number;
  latitude?: number;
  radius?: number;
  radiusUnit?: RadiusUnitEnum;
}
